import request from "@/utils/request";
export function getPage(condition, pagination) {
  return request({
    url: "/crm/call/page",
    method: "post",
    data: { condition: condition, pagination: pagination },
  });
}
export function saveOrUpdate(data) {
  return request({
    url: "/crm/call/saveOrUpdate",
    method: "post",
    data,
  });
}
export function get(id) {
  return request({
    url: "/crm/call/get",
    method: "get",
    params: { id },
  });
}

export function deleteById(id) {
  return request({
    url: "/crm/call/deleteById",
    method: "post",
    data: { id: id },
  });
}
export function submit(id) {
  return request({
    url: "/crm/call/submit",
    method: "post",
    data: { id: id },
  });
}